<script setup lang="ts">
import { computed } from "vue"

type Props = {
    /**
     * Icône à afficher.
     */
    icon: string
    /**
     * Couleur de l'icône.
     */
    color?: string
    /**
     * Taille de l'icône (`font-size`), ex. `var(--text-sm)` ou une valeur en `rem`.
     */
    size?: string
}

const props = defineProps<Props>()

/**
 * Retourne l'icône FontAwesome correspondante.
 * Corrige les préfixes des icônes FontAwesome qui viennent de version précédentes de FontAwesome.
 */
const getIconFontAwesome = computed(() => {
    let icon = props.icon

    if (icon.includes("fad")) {
        icon = icon.replace("fad", "fa-solid")
    } else if (icon.includes("far")) {
        icon = icon.replace("far", "fa-regular")
    } else if (icon.includes("fal")) {
        icon = icon.replace("fal", "fa-light")
    }

    return icon
})
</script>

<template>
    <div class="base-icon">
        <i
            :class="icon"
            v-if="!icon.includes('fa')"
            :style="{ color: color, fontSize: size }"
        ></i>
        <font-awesome-icon
            v-else
            :icon="getIconFontAwesome"
            :style="{ color: color, fontSize: size }"
        />
    </div>
</template>
